export const EmployeeSidebarData = [
  {
    tittle: "Employee",
    showAsTab: false,
    separateRoute: false,
    menu: [
      {
        menuValue: "My Profile",
        hasSubRoute: false,
        showSubRoute: false,
        icon: "la la-user",
        route: "/employee-data",
      },
      {
        menuValue: "My PaySlips",
        hasSubRoute: false,
        showSubRoute: false,
        icon: "la la-file-text",
        route: `/salary-view/${localStorage.getItem("userId")}`, // Fetch dynamically
      },
    ],
  },
];
